const disconnects = new WeakMap();

const handleDisconnect = (controller, disconnect) => {
  if (disconnects.has(controller)) {
    disconnects.set(controller, [...disconnects.get(controller), disconnect]);
    return;
  }

  disconnects.set(controller, [disconnect]);

  const originalDisconnect = controller.disconnect;

  controller.disconnect = () => {
    for (const disconnect of disconnects.get(controller)) {
      disconnect();
    }
    originalDisconnect && originalDisconnect.call(controller);
  };
};

/**
 * Creates stimulus mixin, which also would handle disconnect callback.
 * For executing something on disconnect, you simply need to return a function from mixin.
 * That function would be treated like disconnect function.
 *
 * @param {function(Object): function|void} mixin
 * @return {function(Object): void} mixin made
 */
const createMixin = (mixin) => (controller) => {
  const disconnect = mixin(controller);
  disconnect && handleDisconnect(controller, disconnect);
};

export default createMixin;
